<template>
  <div class="export-calendar text-dark">
    <button @click="setIsModal(true)" class="bttn bttn--is-loading" v-if="isShowButton">
      <spinner size="small" color="blue" v-if="calLink === 'loading'" style="margin: 0;"></spinner>
      <span v-if="calLink.length > 0 && calLink !== 'loading'">{{ $t('vue2.calendar_export.export_calendar') }}</span>
      <span v-if="calLink.length < 1">{{ $t('vue2.calendar_export.guide_to_export_calendar') }}</span>
    </button>
    <d-modal v-if="isModal" :show-close="false" @close="setIsModal(false)">
      <div slot="insertComponent">
        <div class="icon__bg-circle" @click="setIsModal(false)">
          <span class="icon-cross2"></span>
        </div>
        <div class="modal-body">
          <div class="modal__left">
            <h4>{{ $t('vue2.calendar_export.export_calendar_to') }}</h4>
            <ul class="export-calendar__cals">
              <li v-for="integration in integrations" :key="integration.id"
                  :class="{'cal--is-active': theActiveIntegration === integration.id}"
                  @click="theActiveIntegration = integration.id">
                <div class="integration-img" :style="{'background-image': 'url(' + integration.icon + ')'}"></div>
                {{ integration.title }}
              </li>
            </ul>
          </div>
          <div class="modal__right">
            <template v-if="calLink.length > 0">
              <p>{{ $t('vue2.calendar_export.copy_the_url_and_insert') }}</p>
              <input type="text" :value="calLink" class="marg-20-bottom" @click="$event.target.select()">
            </template>
            <h4>{{ $t('vue2.calendar_export.guide_to') }} {{ integrations[theActiveIntegration].title }}</h4>
            <img v-for="img in integrations[theActiveIntegration].imgs" :src="img"/>
          </div>
        </div>
      </div>
    </d-modal>
    <div class="bg-overlay" v-if="isModal" @click="setIsModal(false)"></div>
  </div>
</template>
<script>
import DModal from '../common/DModal'
import Spinner from '../common/Spinner'
import iCalIcon from '../../assets/img/integrations/ical-icon.jpg'
import iCalImport from '../../assets/img/integrations/ical_1.png'
import googleIcon from '../../assets/img/integrations/google-calendar-icon.png'
import googlecalendar1 from '../../assets/img/integrations/googlecalendar1.png'
import googlecalendar2 from '../../assets/img/integrations/googlecalendar2.png'
import googlecalendar3 from '../../assets/img/integrations/googlecalendar3.png'
import outlookIcon from '../../assets/img/integrations/outlook-icon.png'
import outlook1 from '../../assets/img/integrations/outlook1.png'
import outlook2 from '../../assets/img/integrations/outlook2.png'

export default {
  components: {DModal, Spinner},
  props: {
    calLink: {
      default: ''
    },
    isShowButton: {
      type: Boolean,
      default: true
    },
    isShowFromProp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isModal: false,
      theActiveIntegration: 0,
      integrations: [
        {
          id: 0,
          title: 'Google Calendar',
          icon: googleIcon,
          imgs: [googlecalendar1, googlecalendar2, googlecalendar3]
        },
        {
          id: 1,
          title: 'Apple Calendar',
          icon: iCalIcon,
          imgs: [iCalImport]
        },
        {
          id: 2,
          title: 'Outlook Calendar',
          icon: outlookIcon,
          imgs: [outlook1, outlook2]
        }
      ]
    }
  },
  watch: {
    isShowFromProp (val) {
      this.setIsModal(val)
    }
  },
  methods: {
    setIsModal (boolean) {
      this.isModal = boolean
      if (!boolean) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.icon__bg-circle {
  position: absolute;
  top: 4px;
  right: 18px;
}

.modal-body {
  display: flex;
  border-radius: 4px;
}

.modal__left {
  width: 200px;
}

.modal__left h4 {
  padding: 2rem;
}

.modal__right {
  width: 500px;
  height: 500px;
  background-color: #ffffff;
  padding: 2rem;
  overflow: auto;
}

.export-calendar__cals li {
  border-left: 2px solid transparent;
  padding: 1rem 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.export-calendar__cals li.cal--is-active {
  background-color: rgba(70, 138, 215, 0.15);
  border-color: var(--blue);
  font-weight: bold;
  color: var(--blue);
}

.export-calendar__cals li:hover {
  background-color: rgba(70, 138, 215, 0.05);
  border-color: rgba(70, 138, 215, 0.5);
}

.modal__right img {
  width: 100%;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  padding: 4px;
  margin-bottom: 1rem;
}

.integration-img {
  width: 24px;
  height: 24px;
  background-size: cover;
  margin-right: 1rem;
  padding: 4px;
  border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// ExportCalendar.vue?6fd6351f